export function blurInput(target: EventTarget): void {
  if (target instanceof HTMLElement) {
    target.blur();
  }
}
